import React from 'react';
import PropTypes from 'prop-types';

import './ContactsBlock.scss';

const ContactsBlock = ({ data, namesData }) => {
  const { names } = namesData;

  return (
    <div className='contacts' id='contacts_page'>
      <div className='contacts__info'>
        {data &&
          data.length &&
          data.map((d, i) => (
            <div key={i} className='contact'>
              <h3 className='contact__title'>
                <span className='contact__title_text'>{d.title}</span>
              </h3>
              <div
                className='contact__detail'
                dangerouslySetInnerHTML={{ __html: d.contacts }}
              />
            </div>
          ))}
      </div>
      <div className='contacts__names'>
        {names?.length &&
          names.map((n, i) => (
            <div key={i} className='name'>
              <h5>{n.typeTitle}</h5>
              <p>{n.typeText}</p>
            </div>
          ))}
      </div>
    </div>
  );
};

ContactsBlock.propTypes = {
  data: PropTypes.object.isRequired,
  names: PropTypes.array.isRequired,
};

export default ContactsBlock;
